import { Stack } from "@mui/material";
import { ReactComponent as ChatBubbleIcon } from "assets/mail-chat-bubble-square-warning.svg";
import Typography from "components/common/Typography";
import { tokens } from "styles/Tokens";
import { messages } from "utils/CommonConstants";

const NoPropertyPlansBanner = () => {
  return (
    <Stack
      sx={{
        backgroundColor: tokens.Background.General.Primary,
        padding: "16px",
        borderRadius: "12px",
        my: "16px"
      }}
    >
      <Stack
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{
          backgroundColor: tokens.Background.General.Secondary,
          padding: "40px 24px"
        }}
      >
        <ChatBubbleIcon />
        <Typography variant="body1" color={tokens.Text.General.Tertiary}>
          {messages.noPropertyPlans}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default NoPropertyPlansBanner;
